import React, { Component } from 'react';
import { DataTVATaux } from '../../data/DataTVATaux.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxTVA extends Component {

    static defaultProps = {
        idOperation: undefined,
        idProduit: undefined,
        idSousProduit: undefined,
        label: "TVA",
        placeholder: "TVA",
    };

    render = () => {

        const { idProduit, idSousProduit, idOperation } = this.props;

        const extractItems = (reponseAPIobjet) => {
            const items = EUIComboBox.defaultProps.extractItems(reponseAPIobjet);
            const set = new Set(items.map(item => item.taux));
            return Array.from(set).sort((a, b) => a - b);
        };

        let fetchMethod = null;
        if (!!idOperation) {
            const filtres = { idOperation };
            fetchMethod = () => DataTVATaux._chargementListTVATaux(filtres);
        }
        else if (!!idProduit && !!idSousProduit) {
            const filtres = { idProduit, idSousProduit };
            fetchMethod = () => DataTVATaux._chargementListTVATaux(filtres);
        }

        return <EUIComboBox
            {...this.props}
            extractItems={extractItems}
            fetchMethod={fetchMethod}
            itemKey={item => item}
            itemText={item => `${Math.round((item * 100) * 100) / 100} %`}
            stamp={idProduit}
        />;

    };

};